import React, { useEffect } from 'react'
import { useUserContext } from '../../../_context/UserContext'
import { AddedUsers } from '../AddUsers/AddUserComponents/AddedUsers'
import '../AddUsers/AddUsers.css'

export const ViewUsers = () => {
  const { setCurrentPage } = useUserContext();

  useEffect(() => { setCurrentPage("View Users"); }, []);

  return (
    <div className="au-card" style={{ margin: 0 }}>
      <div className="au-card-header">
        <div className="au-card-header-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
          </svg>
        </div>
        <div>
          <p className="au-card-header-title">System Users</p>
          <p className="au-card-header-sub">Browse and manage all system accounts</p>
        </div>
      </div>
      <div className="au-card-body">
        <AddedUsers />
      </div>
    </div>
  );
};
